import { DARK_MUTED } from './darkmuted';

export const BACKGROUND = {
  background: DARK_MUTED.darkmuted700,
  backgroundAlt: DARK_MUTED.darkmuted500,
  backgroundContent: DARK_MUTED.darkmuted700,
  backgroundNavbar: DARK_MUTED.darkmuted600,
  backgroundSidebar: DARK_MUTED.darkmuted500,
};
